import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { Player, Comment } from 'ThreeTerminal_pc_dynamic';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Footer from './footer';

const pickContent = (props, name) => {
    const { content } = props;
    let result = [];

    content.modules.forEach(item => {
        if (name === item.title) result = item.data.articleList;
    });

    result.forEach(item => {
        item.thumbnail = item.thumbnail || (item.thumbnails?.image && item.thumbnails?.image[0]?.url);
    });

    return result;
};

const navData = {
    nav: [
        { title: '凤凰新媒体介绍', url: '//www.ifeng.com/corp/about/intro/' },
        { title: '投资者关系 Investor Relations', url: '//ir.ifeng.com/' },
        { title: '广告服务', url: '//biz.ifeng.com/' },
        { title: '诚征英才', url: '//career.ifeng.com/' },
        { title: '保护隐私权', url: '//www.ifeng.com/corp/privacy/' },
        { title: '免责条款', url: '//www.ifeng.com/corp/exemption/' },
        { title: '意见反馈', url: '//www.ifeng.com/corp/feedback/' },
        { title: '凤凰卫视介绍', url: '//phtv.ifeng.com/intro/' },
    ],
    content: {
        text0: '凤凰新媒体',
        text1: '版权所有',
        text2: 'Copyright © 2019 Phoenix New Media Limited All Rights Reserved.',
    },
};

class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;

        return (
            <div className={styles.layout}>
                <div className={styles.banner} />
                <Videos content={content} />
                <People content={content} />
                <Ad content={content} />
                <Quote content={content} />
                <SlidePic content={content} />
                <CommentComp />
                <div className={styles.nav}>
                    <Footer content={navData} />
                </div>
                <Tab />
            </div>
        );
    }
}

export default errorBoundary(Layout);

const Tab = errorBoundary(props => {
    const [active, setActive] = useState(0);
    const [fixed, setFixed] = useState(false);
    const tabs = ['节目内容', '舍得人物', '往季回顾', '舍得金句', '精彩花絮', '热门评论'];

    const callback = e => {
        let top = document.documentElement.scrollTop;

        if (top > 500 && !fixed) setFixed(true);
        if (top <= 500 && fixed) setFixed(false);
    };

    useEffect(() => {
        window.addEventListener('scroll', callback);

        return () => window.removeEventListener('scroll', callback);
    });

    return (
        <div className={`${styles.tab} ${fixed ? styles.tab_fixed : null}`}>
            {tabs.map((item, index) => {
                return (
                    <div
                        key={index}
                        onClick={() => setActive(index)}
                        className={active === index ? styles.active : null}>
                        <a href={`#content_${index}`}>{tabs[index]}</a>
                    </div>
                );
            })}
        </div>
    );
});

const Videos = errorBoundary(props => {
    const [videoPlay, setVideoPlay] = useState(true);
    const [tab, setTab] = useState(0);
    const sList2 = tab ? pickContent(props, '本期精彩短片2') : [];
    const list = pickContent(props, tab ? '本期精彩短片' : '往期完整视频').concat(sList2);
    const des = pickContent(props, '本期内容&嘉宾介绍')[0];
    const [video, setVideo] = useState(list[0]);

    useEffect(
        () => {
            setVideoPlay(false);
            setTimeout(() => setVideoPlay(true), 100);
        },
        [tab, video],
    );

    useEffect(
        () => {
            setVideo(list[0]);
        },
        [tab],
    );

    return (
        <div className={styles.videoPlay}>
            <a name="content_0" />
            <div className={styles.top}>
                <div>本节目由舍得酒业和凤凰网联合呈现</div>
                <div className={styles.btn}>
                    <div className={tab ? styles.btn_dis : null} onClick={() => setTab(0)}>
                        完整视频
                    </div>
                    <div className={!tab ? styles.btn_dis : null} onClick={() => setTab(1)}>
                        精彩短片
                    </div>
                </div>
            </div>
            <div className={styles.videoBox}>
                <div className={styles.left}>
                    {videoPlay ? (
                        <Player
                            videoConfig={{
                                vid: video.guid,
                                duration: video.duration,
                                videoLargePoster: video.thumbnail,
                                videoPlayUrl: video.videoPlayUrl,
                                title: video.title,
                            }}
                            playermsg={{
                                isAuth: 'auth',
                                height: 376,
                                width: 668,
                                subject: '2020sdzhrw',
                            }}
                        />
                    ) : null}
                </div>
                <div className={styles.right}>
                    {list.map((item, index) => {
                        return (
                            <div onClick={() => setVideo(list[index])} key={item.id} className={styles.item}>
                                <img src={item.thumbnail} alt="" />
                                <div>{item.title}</div>
                            </div>
                        );
                    })}
                </div>
            </div>
            <div className={styles.des}>
                <div>
                    本期内容<br />&<br />嘉宾介绍
                </div>
                <div>{des.summary}</div>
            </div>
        </div>
    );
});

const People = errorBoundary(props => {
    const slide = useRef(null);
    const list = pickContent(props, '舍得人物');
    const rightList = list
        .map((item, index) => {
            item.indexID = index;

            return item;
        })
        .filter((item, index) => {
            return (index + 1) % 3 === 1;
        });
    const [index, setIndex] = useState(0);
    const current = list[index];
    const video = [list[index + 1], list[index + 2]].filter(item => {
        return item.title !== 'false';
    });

    const slideSettings = {
        dots: false,
        autoplay: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
    };

    const SlideCards = () => {
        const piece = [];

        for (let i = 0; i < Math.ceil(rightList.length / 6); i++) {
            const items = rightList.slice(i * 6, (i + 1) * 6);

            piece.push(
                <div key={i} className={styles.piece}>
                    {items.map((item, index) => {
                        return (
                            <div
                                key={index}
                                onClick={() => {
                                    setIndex(item.indexID);
                                }}>
                                <img src={item.thumbnail} alt="" />
                                <div>{item.title}</div>
                                <img src={require('./assets/people_item_botoom.png')} alt="" />
                            </div>
                        );
                    })}
                </div>,
            );
        }

        return piece;
    };

    return (
        <div className={styles.people}>
            <a name="content_1" />
            <div className={styles.people_box}>
                <div className={styles.left}>
                    <img src={current.thumbnail} alt="" />
                    <div>{current.title}</div>
                    <img src={require('./assets/left_b.png')} alt="" />
                    <div>{current.summary}</div>
                    <div className={styles.videos}>
                        {video.map((item, index) => {
                            return (
                                <div
                                    key={index}
                                    onClick={() => {
                                        location.href = item.url;
                                    }}>
                                    <img src={require('./assets/s_play.png')} alt="" />
                                    <div>{item.title}</div>
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div className={styles.right}>
                    <Slider {...slideSettings} ref={slider => (slide.current = slider)}>
                        {SlideCards()}
                    </Slider>
                    <img
                        className={styles.btn_left}
                        src={require('./assets/p_l.png')}
                        onClick={() => {
                            slide.current.slickPrev();
                        }}
                    />
                    <img
                        className={styles.btn_right}
                        src={require('./assets/p_r.png')}
                        onClick={() => {
                            slide.current.slickNext();
                        }}
                    />
                </div>
            </div>
        </div>
    );
});

const Ad = errorBoundary(props => {
    const list = pickContent(props, '往季回顾');
    const ad = pickContent(props, '舍得酒 每一瓶都是老酒')[0];

    return (
        <div className={styles.ad}>
            <a name="content_2" />
            <img
                src={ad.thumbnail}
                alt=""
                onClick={() => {
                    location.href = ad.url;
                }}
            />
            <div className={styles.des}>本节目由舍得酒业和凤凰网联合呈现</div>
            <div className={styles.old}>
                {list.map((item, index) => {
                    return (
                        <div
                            className={styles.old_item}
                            key={index}
                            onClick={() => {
                                location.href = item.url;
                            }}>
                            <div>{item.title}</div>
                            <div>点击观看</div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
});

const Quote = errorBoundary(props => {
    const slide = useRef(null);
    const list = pickContent(props, '舍得金句');
    const [active, setActive] = useState(0);

    return (
        <div className={styles.quote}>
            <a name="content_3" />
            <div className={styles.box}>
                <div className={styles.left}>
                    <div>{list[active].summary}</div>
                    <div>{list[active].title}</div>
                </div>
                <div className={styles.right}>
                    {list.map((item, index) => {
                        return (
                            <div
                                key={index}
                                onClick={() => {
                                    setActive(index);
                                }}
                                className={index === active ? styles.active : null}>
                                {item.title}
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
});

const SlidePic = errorBoundary(props => {
    const slide = useRef(null);
    const list = pickContent(props, '精彩花絮');

    const slideSettings = {
        dots: false,
        autoplay: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
    };

    const SlideCards = () => {
        const piece = [];

        list.forEach((cards, i) => {
            if (!cards.thumbnails) return;

            piece.push(
                <div key={i} className={styles.piece}>
                    {cards.thumbnails.image.map((item, index) => {
                        return (
                            <div key={index}>
                                <img src={item.url} alt="" />
                            </div>
                        );
                    })}
                </div>,
            );
        });

        return piece;
    };

    return (
        <div className={styles.slidePic}>
            <a name="content_4" />
            <img
                style={{ cursor: 'pointer' }}
                src={require('./assets/adjd.jpg')}
                onClick={() => (location.href = 'https://mall.jd.com/index-144509.html')}
            />
            <div className={styles.slide}>
                <Slider {...slideSettings} ref={slider => (slide.current = slider)}>
                    {SlideCards()}
                </Slider>
                <img
                    className={styles.btn_left}
                    src={require('./assets/shallow_l.png')}
                    onClick={() => {
                        slide.current.slickPrev();
                    }}
                />
                <img
                    className={styles.btn_right}
                    src={require('./assets/shallow_r.png')}
                    onClick={() => {
                        slide.current.slickNext();
                    }}
                />
            </div>
        </div>
    );
});

const CommentComp = errorBoundary(() => {
    const commentConfig = {
        docUrl: 'ucms_7xC3zq0Lv28', // 文章单页的页面地址
        docTitle: '凤凰独家|驻美大使崔天凯：不能任由少数人把中美关系拖入冲突对抗的境地', // 文章的标题
        skey: '3e34db', // 文章评论的skey，这个是在后端生成好后给到前端的
        speUrl: '', // 兼容以后的专题评论
        pcUrl: 'https://news.ifeng.com/c/special/7xC3zq0Lv28', // 文章pc的页面地址
        // 获取评论内容接口
        cmtNumUrl: '//comment.ifeng.com/get.php',
        // 评论内容字数长度
        cmtLength: 1000,
        // 提交评论内容接口
        cmtPostUrl: '//comment.ifeng.com/post.php',
        // 最热评论数量
        hotLimit: 2,
        // 推荐评论接口
        cmtVoteUrl: '//comment.ifeng.com/vote.php',
        // 现实回复的楼层
        replyLimit: 3,
        // 举报提交接口
        jubUrl: '//comment.ifeng.com/report',
        // 举报次数，便于每次回调函数名不同
        jubNum: 0,
        // 是否是评论详情页面
        isComment: true,
        // 是否允许评论
        allowComment: true,
        // 'uptimes' 按热度排序，'create_time' 按时间排序， 'both', 两者同时存在
        order: 'both',
        options: 1, // 0 先显示最新，后显示最热，1 反之，此配置在 order 是 both 的情况下才生效
        recentLimit: 20, // 最近评论数量
        recentReplyLimit: 3, // 最近评论数量显示回复的楼层
        showEmptyCommentTip: true, // 是否显示空评论时提示
        usePagination: true, // 是否使用分页
        showTempComment: true, // 是否显示即发即显评论
        // hasIntervalBannerAd: true, // 是否有间隔通栏广告
        // intervalBannerAdData: {
        //     data: { aids: [{ ap: '23942', w: '640', h: '90', res: '1' }] },
        //     preload: '',
        //     callback: 'function(elm, data) {IfengAmgr.show(elm,data);}',
        // }, // 间隔通栏广告数据
        // intervalBannerAdStyle: styles.intervalBannerAd, // 间隔通栏广告自定义样式
    };

    return (
        <div className={styles.comment}>
            <a name="content_5" />
            <div>
                <Comment articleInfo={commentConfig} />
            </div>
        </div>
    );
});
